import React from 'react'

const NotFoundPage = () => <div>Oops! We couldn`&apos;`t find the page you were looking for.</div>

export default NotFoundPage
